import { render, staticRenderFns } from "./DnBeamScientistsList.vue?vue&type=template&id=ce9fdc08&scoped=true&"
import script from "./DnBeamScientistsList.vue?vue&type=script&lang=js&"
export * from "./DnBeamScientistsList.vue?vue&type=script&lang=js&"
import style0 from "./DnBeamScientistsList.vue?vue&type=style&index=0&id=ce9fdc08&scoped=true&lang=scss&"
import style1 from "./DnBeamScientistsList.vue?vue&type=style&index=1&id=ce9fdc08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce9fdc08",
  null
  
)

export default component.exports